import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "@/lib/cn";

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

/** Text input. Border + focus ring use brand tokens; placeholder contrast is held >= 4.5:1. */
export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, type, ...props },
  ref,
) {
  return (
    <input
      ref={ref}
      type={type ?? "text"}
      className={cn(
        "h-9 w-full rounded-(--radius-sm) bg-(--surface) px-3 text-(length:--text-sm) text-(--text) " +
          "border border-(--border-input) placeholder:text-(--text-placeholder) " +
          "transition-[border-color,box-shadow] duration-(--dur-fast) ease-(--ease-out) " +
          "hover:border-(--border-strong) " +
          "focus:border-(--brand) focus:shadow-[0_0_0_3px_var(--ring)] " +
          "focus-visible:outline-none " +
          "aria-invalid:border-(--danger) aria-invalid:hover:border-(--danger) " +
          "disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-(--surface-sunken)",
        className,
      )}
      {...props}
    />
  );
});
